export const buildNumber = '20260623.5';
export const version = 'main';
export const latestCommit = '0e906b853040c6e54b00eea489eefe24cc0f110b';
